<template>
    <div class="container">
        <Nav></Nav>
        <div class="banner">
        </div>
        <div class="bread">
            <div>
                <div class="bread-mulu">
                    <img src="../assets/images/newlist-mulu.png" alt="" @click="$router.push({path:'/'})" style="cursor:pointer">
                    <span></span>
                    <p @click="$router.push({path:'/newscenter'})" style="cursor:pointer">新闻中心</p>
                    <span></span>
                    <p class="br-name">{{name}}</p>
                </div>
            </div>
        </div>
        <div class="con" v-for="(item,index) in list" :key="index" @click="toDetail(item.Id)">
            <span class="con-top"></span>
            <div class="con-img">
                <img :src="item.ImageUrl" alt="">
            </div>
            <div class="con-con">
                <p class="title">{{item.Title}}</p>
                <!-- <p class="content">周，全球领先的人工智能平台公司商汤科技与中国物业管理行业践行者蓝光嘉宝服务在成都举行“商汤-嘉宝联合实验室揭牌仪式你开局考试需看到了·你看了哪里能看看·看看哪款你看辽宁科技老奶奶和你还可能仅仅两款i111笔记本不合格还不够好VGuu1不会尽快</p> -->
                <p class="content">{{item.Text}}</p>
                <div class="box">
                    <p>{{item.AddDateTime}}
                    </p>
                    <div v-if="item.GzhUrl">
                        <img class="active-code" :src="item.GzhUrl" alt="">
                    </div>
                </div>
            </div>
            <div class="con-more">
                <!-- <img src="../assets/images/newlist-more.png" alt=""> -->
                <!-- <img src="" style="width:100%;height:100%"/> -->
            </div>
        </div>
        <div class="con-page">
              <Page :total="Total"
              class="conpage"
              :current="current"
              :page-size="Size"
              @on-change="changePage"
                prev-text="上一页"
                next-text="下一页"
        ></Page>
        </div>
         <Footer></Footer>
    </div>
</template>

<script>
import Nav from '@/components/topNav.vue'
import Footer from '@/components/footer.vue'

export default {
  components: {
    Nav,
    Footer
  },
  data () {
    return {
      name: '', // 类型名称
      list: [],
      Page: 1, // 当前页
      Size: 10, // 页面大小
      Total: 1, // 总页数
      IndustryType: '', // 新闻类型
      current: 1 // 当前页
    }
  },
  mounted () {
    // console.log(this.$route.query.id, 'query')
    let type = this.$route.query.id
    if (type == 1) {
      this.name = '住房城乡建设行业'
    } else if (type == 2) {
      this.name = '交通运输行业'
    } else if (type == 3) {
      this.name = '食药安全行业'
    } else if (type == 4) {
      this.name = '医疗卫生行业'
    } else {
      this.name = '其他行业'
    }
    this.IndustryType = this.$route.query.id
    this.getList()
  },
  methods: {
    getList () {
      let that = this
      this.axios({
        method: 'GET',
        url: '/api/News/GetPageList',
        params: {
          page: that.Page,
          size: that.Size,
          IndustryType: that.IndustryType
        }
      })
        .then(result => {
        //   console.log(result, 'result')
          if (result.data.success) {
            let data = result.data.data
            that.list = data.Data
            that.Total = data.Total
          }
        //   console.log(that.Total, 'that.Total')
        })
        .catch(err => {
          console.log(err)
        })
    },
    toDetail (id) {
    //   console.log(id, 'id')
      this.$router.push({path: '/newsdetail?id=' + id})
    },
    changePage (data) {
    //   console.log(data, 'idd')
      this.Page = data
      this.getList()
    }
  }
}
</script>
<style scoped>
.banner{
    width: 100%;
    height: 300px;
    background: url("../assets/images/newslist-banner.png") no-repeat center;
    overflow: hidden;
}
.bread{
    width: 100%;
  height: 56px;
  background: #FBFBFB;
}
.bread div{
    width: 1200px;
    margin: 0px auto;
}
.bread .bread-mulu{
    width: 222px;
    float: left;
    line-height: 56px;
    display: flex;
    justify-content: space-between;
}
.bread .bread-mulu img{
    width:12px;
    height: 12px;
    align-self: center;
    vertical-align: 0px;
}
.bread .bread-mulu span{
    display: inline;
    width: 0px; /*  宽高设置为0，很重要，否则达不到效果 */
    height: 0px;
    border: 5px solid #727272;
    border-top-color: transparent; /*设置透明背景色*/
    border-right-color: transparent;
    border-bottom-color: transparent;
    align-self: center;
    margin-right:-15px;
}
.bread .bread-mulu .br-name{
    color: #B00000;
}
/* .container{
    overflow: hidden;
} */
.con{
    position: relative;
    width: 1200px;
    height: 240px;
    /* background-color: orange; */
    margin: 0 auto 20px;
    /* background-image:url('../assets/images/newslist-bgc.png');
    background-position: 50%;
    background-size: cover; */
    /* background-repeat: no-repeat; */
    display: flex;
    justify-content: space-evenly;
    /* background-color: #fff; */
    box-shadow: 2px 2px 17px 3px rgba(87, 87, 87, 0.17);
}

.con:hover{
    background:#818694;
    /* background-position: 0px 0px; */
        transition: all 1.5s cubic-bezier(.2,.8,.2,1);
        cursor: pointer;
}
.con .con-top{
    display: inline-block;
    width: 100%;
    height: 4px;
    background-color: #B00000;
    position: absolute;
    top: 0px;
    left: 0px;
    display: none;
}
.con:hover .con-top{
    display: inline-block;
}
.con .con-img{
    align-self: center;
}
.con .con-img img{
    width:310px ;
    height: 200px;
}
.con .con-con{
    width: 800px;
    height:200px;
    /* background-color: pink; */
    align-self: center;
}
.con .con-con .title{
    font-size: 20px;
    font-family: PingFang SC;
    font-weight: bold;
    color: #333;
    margin-top: 6px;
    display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;

}
.con:hover .con-con .title{
    color: #fff;
}
.con .con-con .content{
    height: 45px;
    width: 710px;
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: #333;
    margin-top: 30px;
    line-height: 25px;
    display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  overflow: hidden;
}
.con:hover .con-con .content{
    color: #fff;
}
.con .con-con .box{
    background-image: url('../assets/images/newlist-colock1.png');
    background-repeat: no-repeat;
    background-position: 0px 3px;
    position: relative;
    /* background-image: url('../assets/images/newscenter/index-code.png');
    background-repeat: no-repeat;
    background-position: 20px 3px; */
}
.con:hover .con-con .box{
    background-image: url('../assets/images/newlist-colock.png');
    background-repeat: no-repeat;
    background-position: 0px 3px;

}
.con .con-con .box p{
    margin: 64px 0px 0px 21px;
    color: #999;
     /* background-image: url('../assets/images/newscenter/index-code.png');
    background-repeat: no-repeat;
    background-position: 110px 0px; */
}
.con:hover .con-con .box p{
     /* background-image: url('../assets/images/newscenter/index-code1.png');
    background-repeat: no-repeat;
    background-position: 110px 0px; */
}
.con:hover .con-con .box p{
    color: #fff;
}
.con .con-con .box div{
    position: absolute;
    width: 17px;
    height: 17px;
    background-color: transparent;
    top: 0px;
    left: 132px;
    background-image: url('../assets/images/newscenter/index-code.png');
    background-repeat: no-repeat;
    background-position: center;
}
.con:hover .con-con .box div{
     background-image: url('../assets/images/newscenter/index-code1.png');
    background-repeat: no-repeat;
    background-position: center;
}
.con .con-con .box div .active-code{
    position: absolute;
    width: 120px;
    height: 120px;
    bottom: 24px;
    left: 1px;
    display: none;
}
.con .con-con .box div:hover .active-code{
    display: inline-block;
}
.con .con-more{
    width: 15px;
    height: 25px;
    background-image: url('../assets/images/newlist-more.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    align-self: center;
}
.con:hover .con-more{
    width: 15px;
    height: 25px;
    background-image: url('../assets/images/newslist-more1.png');
    background-position: center;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    align-self: center;
}
.con-page{
    margin: 20px auto 20px;
    text-align: center;
    margin-bottom: 30px;
}
</style>
<style>
.con-page .ivu-page .ivu-page-prev{
    width: 80px;
    border: 1px solid #E2E2E2;
    color: #999999;
}
.con-page .ivu-page-prev a{
    color: #999999;
}
.con-page .ivu-page .ivu-page-item a{
    color: #999;
}
.con-page .ivu-page .ivu-page-next{
    width: 80px;
    border: 1px solid #E2E2E2;
    color: #999999;
}
.con-page .ivu-page-next a{
    color: #999999;
}
.con-page .ivu-page .ivu-page-item:hover{
    border: 1px solid #B00000;
}
.con-page .ivu-page .ivu-page-item-active{
    border: none;
    background: #B00000;
}
.con-page .ivu-page .ivu-page-item-active a{
    color: #fff;
}
/* .con-page .ivu-page .ivu-page-item-active{
    border: none;
   background-color: #B00000;
}
.con-page .ivu-page .ivu-page-item-active a{
    color: #fff;
}
.ivu-page-item-active a{
    color: red !important;
} */
</style>



// WEBPACK FOOTER //
// src/views/newsList.vue